// @ts-nocheck

import * as Types from '../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type ValidateImporterRowQueryVariables = Types.Exact<{
  input: Types.ReferenceIdRowValidationQueryModelInput;
}>;

export type ValidateImporterRowQuery = {
  validateReferenceIdsRow: {
    validations?: Array<{
      urn?: string | null;
      index?: number | null;
      result?: { valid?: boolean | null; message?: string | null } | null;
    } | null> | null;
  };
};

export const ValidateImporterRowDocument = gql`
    query ValidateImporterRow($input: ReferenceIdRowValidationQueryModelInput!) {
  validateReferenceIdsRow(input: $input) {
    validations {
      urn
      index
      result {
        valid
        message
      }
    }
  }
}
    ` as unknown as DocumentNode<ValidateImporterRowQuery, ValidateImporterRowQueryVariables>;
